import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  html,
  #root {
    height: 100%;
    background: transparent;
  }

  body {
    font-family: 'Source Sans Pro', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #f2f3f5;
    overflow: hidden;
    backface-visibility: hidden;
    will-change: overflow;
  }

  body[data-theme="light"] {
    background-color: #f2f3f5;
  }

  body[data-theme="dark"] {
    background: radial-gradient(circle at 80% 20%, rgba(30, 80, 255, 0.35) 0%, transparent 50%),
      radial-gradient(circle at 20% 80%, rgba(0, 50, 150, 0.25) 0%, transparent 60%),
      linear-gradient(135deg, #020c1b 0%, #122c4a 100%);
  }

  body[data-theme="dark"] .suppliers-main-sidebar .MuiPaper-root {
    background-color: #020c1b !important;
  }

  .shadow-scroll {
    background:
    linear-gradient(white 0%, hsla(0,0%,100%, 0)),
    linear-gradient(hsla(0,0%,100%,0) 10px, white 0%) bottom,
    radial-gradient(at top, rgb(227,227,227), transparent 90%), 
    radial-gradient(at bottom, rgb(227,227,227), transparent 90%) bottom;
    background-repeat: no-repeat;
    background-size: 100% 20px, 100% 20px, 100% 10px, 100% 10px;
    background-attachment: local, local, scroll, scroll;
    background-color: white;
  }

  a {
    text-decoration: none;
  }

  a:-webkit-any-link {
    appearance: none;
  }

  body[data-theme='dark'] .filter-menu-sci-trigger {
    color: rgba(255, 255, 255, 0.9);
    background-color: #263e59;
    border: 1px solid rgba(30, 80, 255, 0.14);
    box-sizing: border-box;
  }

  body[data-theme='dark'] .filter-menu-sci-trigger:hover,
  body[data-theme='dark'] .filter-menu-sci-trigger:focus {
    background-color: #2f4a68;
  }

  body[data-theme='dark'] .filter-menu-sci-trigger svg {
    color: rgba(255, 255, 255, 0.75);
  }

  body[data-theme='dark'] .filter-menu-sci-trigger input {
    color: rgba(255, 255, 255, 0.9);
  }

  body[data-theme='dark'] .filter-menu-sci-trigger input::placeholder {
    text-transform: none;
    color: rgba(255, 255, 255, 0.42);
    -webkit-text-fill-color: rgba(255, 255, 255, 0.42);
    font-size: 13px;
    opacity: 1;
  }

  body[data-theme='dark'] .filter-menu-sci-trigger .MuiInputAdornment-root,
  body[data-theme='dark'] .filter-menu-sci-trigger span {
    color: rgba(255, 255, 255, 0.9);
  }

  #fc_frame,
  #fc_frame.fc-widget-normal,
  #fc_frame.fc_l2r,
  #fc_frame.fc-widget-normal.fc_l2r {
    display: none !important;
  }
`;
